export function generateDealCloneName(name: string): string {
  const dealNameAutogeneratedPartMatch: RegExpMatchArray = name?.match(/-CLONE(\d+)$/);
  const dealNameAutogeneratedPart : string = (dealNameAutogeneratedPartMatch?.length > 1) ? dealNameAutogeneratedPartMatch[1] : null;
  const autogeneratedPart: string = `${(~~(Date.now() / 1000))}`.slice(-5);
  if (dealNameAutogeneratedPart != null) {
    return name?.replace(dealNameAutogeneratedPart, autogeneratedPart);
  } else {
    return `${name}-CLONE${autogeneratedPart}`;
  }
}
